function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["checked", "value", "className", "variant", "icon", "label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { RadioContext, getInputProps } from "./RadioGroup";
import { onRadioKeyPress, useIcon } from "../../helpers";
import { useId } from "../../helpers/hooks";
var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
    value = _ref.value,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    variant = _ref.variant,
    icon = _ref.icon,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = useId();
  var labelId = "texada-ui-radio-".concat(id);
  var context = useContext(RadioContext);
  var inputProps = getInputProps(context, _objectSpread({
    checked: checked,
    value: value
  }, props));
  var iconToRender = useIcon(icon);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("tui-radio button", className, _defineProperty(_defineProperty({}, variant, variant), "checked", inputProps.checked)),
    role: "radio",
    "aria-checked": inputProps.checked,
    tabIndex: inputProps.disabled ? -1 : 0,
    "aria-disabled": inputProps.disabled,
    onKeyPress: onRadioKeyPress(labelId)
  }, /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    id: labelId,
    tabIndex: "-1",
    type: "radio",
    onChange: function onChange(e) {
      if (inputProps.checked && inputProps.onClick) {
        inputProps.onClick(e);
        return;
      }
      inputProps.onChange(e);
    }
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: labelId
  }, icon && iconToRender, label));
};
RadioButton.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.any,
  label: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.func
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map